export const actionTypes = {
  FETCH_PROVIDER_ERP_INVOICES: "FETCH_PROVIDER_ERP_INVOICES",
  SET_PROVIDER_ERP_INVOICES: "SET_PROVIDER_ERP_INVOICES",
  SET_PROVIDER_ERP_INVOICES_LOADING: "SET_PROVIDER_ERP_INVOICES_LOADING",
  SET_PROVIDER_ERP_INVOICES_ERROR: "SET_PROVIDER_ERP_INVOICES_ERROR",
};
